module.exports = __webpack_public_path__ + "img/direct-debit.d2d50a25.png";